import React, { useState, useCallback } from "react";
import { Layout, Spin } from "antd";
import classnames from "classnames";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import _ from "lodash";
import { GatesProvider } from "@/gates";
import policies from "@/gates/policies";
import { defaultHandler } from "@/gates/policies/handlers";
import { slices } from "@/constants/sliceNames";

import Learn from "../Learn/Learn";

import Header from "./Header";
import Footer from "./Footer";
import SideBar from "./SideBar";
import Content from "./Content";

import "./Layout.scss";

const AppLayout = ({ className, ...rest }) => {
  const [isLearnOpen, setIsLearnOpen] = useState(false);
  const fetchDone = useSelector((state) => state[slices.auth].fetchDone);

  const learnClickHandler = useCallback(() => {
    setIsLearnOpen((prev) => !prev);
  }, []);

  const { userInfo } = useSelector((state) => state[slices.auth]);
  const { permissions } = useSelector((state) => state[slices.authorization]);

  return (
    <>
      <Spin spinning={!fetchDone}>
        <GatesProvider
          user={_.size(userInfo) && userInfo}
          policies={policies}
          permissions={permissions}
          defaultHandler={defaultHandler}
        >
          <Layout className={`app-layout ${className}`} style={{ minHeight: "100vh" }}>
            <Header onLearnClick={learnClickHandler} isLearnOpened={isLearnOpen} />
            <Layout>
              <SideBar />
              <Layout>
                <Content className="site-layout-content">
                  <Outlet />
                </Content>
                <Footer />
              </Layout>
              <Learn className={classnames({ "learn--open": isLearnOpen })} onToggle={learnClickHandler} />
            </Layout>
          </Layout>
        </GatesProvider>
      </Spin>
    </>
  );
};

export default React.memo(AppLayout);
